import PropTypes from 'prop-types';
import { ArticleCard } from '@bwoty-web/ui-kit';
import { useIsGlobetrotter } from '@bwoty-web/ui-kit/hooks';

import { itemTypes } from '../../../utils/geoTypeUtils';
import './ResortListItem.scss';

const ResortListItem = ({
  parentItemType,
  resort,
  labels,
  imageAspectRatio = null,
  withBackground = undefined,
}) => {
  const isGlobe = useIsGlobetrotter();
  const {
    name,
    numberOfHotels,
    numberOfResorts,
    cloudinaryImage,
    description,
    url,
    productInfo,
  } = resort;

  const linkList = [];
  if ([itemTypes.country, itemTypes.area, itemTypes.region].includes(parentItemType)) {
    if (numberOfHotels) {
      linkList.push({
        href: `${url}${labels.hotelTabLinkUrl}`,
        text: `${numberOfHotels} ${labels.hotelLinkText}`,
      });
    }
    if (numberOfResorts) {
      linkList.push({
        href: `${url}#resort-list-view`,
        text: `${numberOfResorts} ${labels.numberOfResortsLinkText}`,
      });
    }
  }

  return (
    <ArticleCard
      buttonText={labels.readMoreButtonText}
      buttonVariant="tertiary"
      columnSpan={isGlobe ? 3 : 4}
      description={description}
      image={cloudinaryImage}
      imageAspectRatio={imageAspectRatio || 4 / 5}
      imagePosition="top"
      imageTags={
        productInfo?.isSuitableForTraining
          ? [labels.isSuitableForTrainingText]
          : null
      }
      {...(!isGlobe && { linkList })}
      title={name}
      url={url}
      withBackground={withBackground}
    />
  );
};

ResortListItem.propTypes = {
  parentItemType: PropTypes.string.isRequired,
  resort: PropTypes.shape({
    name: PropTypes.string.isRequired,
    cloudinaryImage: PropTypes.shape({
      cloudinaryUriTemplate: PropTypes.string.isRequired,
      size: PropTypes.shape().isRequired,
    }).isRequired,
    url: PropTypes.string.isRequired,
    description: PropTypes.string,
    numberOfHotels: PropTypes.number,
    numberOfResorts: PropTypes.number,
    productInfo: PropTypes.shape({
      isSuitableForTraining: PropTypes.bool,
    }),
    conceptBanners: PropTypes.arrayOf(
      PropTypes.shape({
        key: PropTypes.string.isRequired,
      }),
    ),
  }).isRequired,
  labels: PropTypes.shape({
    hotelLinkText: PropTypes.string.isRequired,
    hotelTabLinkUrl: PropTypes.string,
    isSuitableForTrainingText: PropTypes.string.isRequired,
    numberOfResortsLinkText: PropTypes.string.isRequired,
    readMoreButtonText: PropTypes.string.isRequired,
  }).isRequired,
  imageAspectRatio: PropTypes.number,
  withBackground: PropTypes.bool,
};

export default ResortListItem;
